<template>
  <span
    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium"
    :class="badgeClasses">
    {{ verified ? verifiedText : pendingText }}
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  verified: {
    type: Boolean,
    default: false
  },
  verifiedText: {
    type: String,
    default: 'Verified'
  },
  pendingText: {
    type: String,
    default: 'Pending'
  }
})

const badgeClasses = computed(() => (props.verified ?
  'bg-emerald-100 dark:bg-emerald-900/20 text-emerald-800 dark:text-emerald-400' :
  'bg-amber-100 dark:bg-amber-900/20 text-amber-800 dark:text-amber-400'))
</script>
